import { createUseStyles } from 'react-jss';
import { ITheme, mediaQuery } from '@quicktools/shared-components';

const useStyles = createUseStyles(
  ({ breakpoints }: ITheme) => ({
    root: {
      background: 'none',
      flex: 1,

      [mediaQuery(breakpoints.mobile)]: {
        maxWidth: '100%',
      },
    },
  }),
  { name: 'Generator' },
);

export default useStyles;
